<script>
import axios from 'axios'
import SerialSearch from '@components/serial-search'

export default {
  name: 'CreateDeviceDialog',
  components: {
    SerialSearch,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      required: false,
      default: null,
    },
    oldItem: {
      type: Object,
      required: false,
      default: null,
    },
    workshopId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    fromWorkshop: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      formValidState: false,
      isLoading: false,
      rules: {
        fromWarehouse: [x => !!x || this.$t('validation__is_required')],
        oil: [x => !!x || this.$t('validation__is_required')],
        drum: [x => !!x || this.$t('validation__is_required')],
        serial: [x => !!x || this.$t('validation__is_required')],
        serial_text: [
          x =>
            (!!x && /^[A-Z0-9]+$/.test(x)) ||
            this.$t('validation__is_capital_latin_and_digits'),
        ],
      },
    }
  },
  computed: {
    oils() {
      return this.$store.getters['data/getOil']
    },
    drums() {
      return this.$store.getters['data/getDrum']
    },
    dialogShow: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    warehouses() {
      return this.$store.getters['data/getWarehouses']
    },
    notChanged() {
      return (
        this.item.oil === this.oldItem.oil &&
        this.item.drum === this.oldItem.drum
      )
    },
  },
  methods: {
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value ? Number(value) : value
      )
    },
    submit() {
      const isFormValid = this.$refs.newItemForm.validate()
      if (!isFormValid) return
      if (
        this.item.serial === this.oldItem.serial &&
        this.item.oil === this.oldItem.oil &&
        this.item.drum === this.oldItem.drum &&
        this.item.doShipment === this.oldItem.doShipment &&
        this.item.organisation === this.oldItem.organisation
      ) {
        return
      }

      const fromOrganisation = this.workshopId
        ? this.workshopId
        : this.item.organisation
      const toOrganisation = this.workshopId
        ? this.workshopId
        : this.item.organisation

      this.isLoading = true
      axios
        .put(`/api/1/devices`, {
          serial: this.item.serial,
          oilId: this.item.oil,
          drumId: this.item.drum,
          fromOrganisation,
          toOrganisation,
          doShipment: this.item.doShipment,
        })
        .then(response => {
          this.isLoading = false
          this.$refs.newItemForm.reset()
          this.$emit('on-created')
        })
        .catch(error => {
          this.isLoading = false
          console.error(error)
        })
    },
    closeDialog() {
      this.$refs.newItemForm.reset()
      this.$emit('close-clicked')
    },
  },
}
</script>
<template>
  <v-dialog
    v-model="dialogShow"
    :content-class="$style.relativePosition"
    persistent
    max-width="500px"
  >
    <v-card>
      <v-card-title>
        <v-spacer />
        <div
          class="headline">{{ $t('titles__edit_device') }}</div>
        <v-spacer />
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex
              xs12
              class="text-xs-center"
            >
              <v-form
                ref="newItemForm"
                v-model="formValidState">
                <v-layout
                  row
                  align-center>
                  <v-flex>
                    <v-text-field
                      v-model="item.serial"
                      :label="$t('label__device_serial')"
                      disabled
                    />
                  </v-flex>
                </v-layout>
                <v-layout column>
                  <!--                  <v-flex v-show="!workshopId">-->
                  <!--                    <v-select-->
                  <!--                      :items="warehouses"-->
                  <!--                      :disabled="!!workshopId"-->
                  <!--                      :label="$t('label__toWarehouse')"-->
                  <!--                      :rules="rules.fromWarehouse"-->
                  <!--                      v-model="item.organisation"-->
                  <!--                      item-text="shortName"-->
                  <!--                      item-value="id"-->
                  <!--                      required-->
                  <!--                      autocomplete-->
                  <!--                    />-->
                  <!--                  </v-flex>-->
                  <v-flex>
                    <v-select
                      :items="drums"
                      :label="$t('label__drum')"
                      :rules="rules.drum"
                      v-model="item.drum"
                      item-text="shortName"
                      item-value="id"
                      required
                      autocomplete
                    />
                  </v-flex>
                  <v-flex>
                    <v-select
                      :items="oils"
                      :label="$t('label__oil')"
                      :rules="rules.oil"
                      v-model="item.oil"
                      item-text="shortName"
                      item-value="id"
                      required
                      autocomplete
                    />
                  </v-flex>
                  <v-flex>
                    <v-checkbox
                      v-if="fromWorkshop"
                      v-model="item.doShipment"
                      :label="$t(`label__shipment`)"
                      primary
                      hide-details
                      @click.stop
                    />
                  </v-flex>
                </v-layout>
              </v-form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
          :disabled="isLoading"
          color="secondary"
          @click="closeDialog">{{ $t('buttons__close') }}</v-btn>
        <v-btn
          :disabled="!formValidState || isLoading || notChanged"
          :loading="isLoading"
          color="success"
          @click="submit">{{ $t('buttons__update') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<style lang="scss" module>
@import '@design';

.relativePosition {
  position: relative;
}
</style>
